module.exports = __webpack_public_path__ + "img/star.77188894.svg";